module.exports = __webpack_public_path__ + "static/media/indexPageImg.59a21491.png";